'use client';

import { useGtmTrack } from '../index';
import { ANALYTICS_EVENTS } from '../types';
import type { FAQArrowClickedProps, TrackingFunction } from '../types';

export const useFAQArrowTracking = (props: FAQArrowClickedProps, autoTrack: boolean = false): TrackingFunction => {
  return useGtmTrack(
    {
      eventName: ANALYTICS_EVENTS.FAQ_ARROW_CLICKED,
      properties: props,
    },
    autoTrack,
  );
};
